import type { SvgComponent } from '@/types/SvgComponent';

export const ThreeDotsVerticalIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <g clipPath="url(#clip0_36_616)">
        <path
          d="M12 13.125C12.6213 13.125 13.125 12.6213 13.125 12C13.125 11.3787 12.6213 10.875 12 10.875C11.3787 10.875 10.875 11.3787 10.875 12C10.875 12.6213 11.3787 13.125 12 13.125Z"
          fill="currentColor"
        />
        <path
          d="M12 6.75C12.6213 6.75 13.125 6.24632 13.125 5.625C13.125 5.00368 12.6213 4.5 12 4.5C11.3787 4.5 10.875 5.00368 10.875 5.625C10.875 6.24632 11.3787 6.75 12 6.75Z"
          fill="currentColor"
        />
        <path
          d="M12 19.5C12.6213 19.5 13.125 18.9963 13.125 18.375C13.125 17.7537 12.6213 17.25 12 17.25C11.3787 17.25 10.875 17.7537 10.875 18.375C10.875 18.9963 11.3787 19.5 12 19.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_36_616">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
